import { render, staticRenderFns } from "./WantFollow.vue?vue&type=template&id=579117bd&scoped=true&"
import script from "./WantFollow.vue?vue&type=script&lang=js&"
export * from "./WantFollow.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=579117bd&prod&scoped=true&lang=css&"
import style1 from "./WantFollow.vue?vue&type=style&index=1&id=579117bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579117bd",
  null
  
)

export default component.exports